import http from '../_util/http';
import mapTool from '../_util/mapTool';

export const transformLonLatToWGS84 = (lonLat, coordType) => {
    let _lonLat = [...lonLat].map(v => Number(v));
    if (coordType === 'bmap') {
        let gcj = mapTool.bd09togcj02(lonLat[0], lonLat[1]);
        _lonLat = mapTool.gcj02towgs84(gcj[0], gcj[1]);
    } else if (coordType === 'amap') {
        _lonLat = mapTool.gcj02towgs84(lonLat[0], lonLat[1]);
    }

    return _lonLat;
};

export const transformGeometryInfoToWGS84 = (lngLats, type, coordType) => {
    let lngLatArr = [];
    if (lngLats) {
        if (type === 'point') {
            let _l = typeof lngLats === 'string' ? lngLats.split(',') : lngLats;
            lngLatArr = transformLonLatToWGS84(_l, coordType);
        } else if (['polygon', 'polyline'].includes(type)) {
            lngLatArr[0] = [];
            lngLats.split(';').map(res => {
                let [lng, lat] = res.split(',');
                lngLatArr[0].push(transformLonLatToWGS84([Number(lng), Number(lat)], coordType));
            });
        } else {
            if (Array.isArray(lngLats)) {
                lngLatArr = lngLats;
            }
        }
    }

    return lngLatArr;
};

export const transformGeometry = geometryInfo => {
    /**
     * geometry: {
     *  "type": "Point | LineString | Polygon | MultiPoint | MultiLineString | MultiPolygon | GeometryCollection",
     *  "coordinates": []
     * }
     */

    let { type, lngLats, coordType, shapeType, coordinateType } = geometryInfo;
    type = type || shapeType;
    coordType = coordType || coordinateType;

    /**
     * geometryInfo: {
     *  coordType: "wgs84"
     *  lngLats: "119.02486914921874,25.63890915087647"
     *  type: "point"
     * }
     */

    let _type = type.replace(/^\S/, s => s.toUpperCase());

    return {
        type: _type,
        coordinates: transformGeometryInfoToWGS84(lngLats, type, coordType),
    };
};

export const createFeature = (v, field) => {
    return {
        type: 'Feature',
        geometry: transformGeometry(v[field || 'geometryInfo']),
        properties: { ...v },
    };
};

export const createFeatureCollection = (data, field) => {
    field = field || 'geometryInfo';
    const featureCollection = {
        type: 'FeatureCollection',
        features: [],
    };

    let features = [];
    data.map(v => {
        if (v[field]) {
            features.push(createFeature(v, field));
        }
    });

    featureCollection.features = features;

    return featureCollection;
};

export const getDataByHttp = (url, params, method, afterGetData) => {
    let request = http.get;
    if (method === 'POST' || method === 'post') {
        request = http.post;
    }
    return request(url, {body: params}).then(res => {
        res = afterGetData ? afterGetData(res) : res;

        if (url.indexOf('/geoserver/') !== -1) {
            return res;
        }

        if (res?.data?.length) {
            return createFeatureCollection(res.data);
        }
    });
};

export const getDataByHttpByParams = ({ url, params, method, afterGetData, field }) => {
    let request = http.get;
    if (method === 'POST' || method === 'post') {
        request = http.post;
    }
    return request(url, {body: params}).then(res => {
        res = afterGetData ? afterGetData(res) : res;

        if (url.indexOf('/geoserver/') !== -1) {
            return res;
        }

        if (res?.data?.length) {
            return createFeatureCollection(res.data, field);
        }
    });
};
